module.exports = __webpack_public_path__ + "assets/img/b4-9.6aac1ada.png";